
import "./product-list.scss";

const ProductList: React.FC = () => {
  return <div className="product-list-wrapper">
    <h1>Product list</h1>
  </div>;
};

export default ProductList;